import api from './api';

/**
 * Report Service
 * Handles all API calls for the Reports & Analytics module
 */

// Fetch general reports
export const getGeneralReports = (filters) => {
    return api.get('/transporteur/reports/general', { params: filters });
};

// Fetch subcontracting reports
export const getSubcontractingReports = (filters) => {
    return api.get('/transporteur/reports/subcontracting', { params: filters });
};

// Fetch driver reports
export const getDriverReports = (filters) => {
    return api.get('/transporteur/reports/drivers', { params: filters });
};

// Fetch vehicle reports
export const getVehicleReports = (filters) => {
    return api.get('/transporteur/reports/vehicles', { params: filters });
};

// Fetch kilometer reports
export const getKilometerReports = (filters) => {
    return api.get('/transporteur/reports/kilometers', { params: filters });
};

// Fetch billing reports
export const getBillingReports = (filters) => {
    return api.get('/transporteur/reports/billing', { params: filters });
};

// Export data
export const exportReport = (reportType, format, filters, options) => {
    return api.post(
        '/transporteur/reports/export',
        { reportType, format, filters, options },
        { responseType: 'blob' }
    );
};

// Saved views management
export const getSavedViews = () => {
    return api.get('/transporteur/reports/views');
};

export const createSavedView = (view) => {
    return api.post('/transporteur/reports/views', view);
};

export const updateSavedView = (id, view) => {
    return api.put(`/transporteur/reports/views/${id}`, view);
};

export const deleteSavedView = (id) => {
    return api.delete(`/transporteur/reports/views/${id}`);
};
